<template>
    <div id="order-detail-dp">
        <v-layout row wrap>
            <v-flex xs12 sm6 offset-sm3 class="mt-2">

                <div v-if="receivedIoTMessage.length">
                    <v-card class="pa-3">
                        <h3>最新の情報:</h3>
                        <div v-for="(msg,msgIndex) in receivedIoTMessage" :key="'mqttMsg_'+msgIndex">
                            <v-alert
                                    :value="true"
                                    :type="msg.type"
                            >
                                {{msg.text}}
                            </v-alert>
                            <v-img
                                    :src="require('../assets/veryVerySorry.jpg')"
                                    v-if="msg.veryVerySorry"
                            >
                            </v-img>
                            <p>{{msg.timeStr}}</p>
                        </div>

                    </v-card>
                </div>

                <h3 class="pa-1">お取引記録</h3>
                <v-list two-line v-for="(obj,index) in statusHistory" :key="'statusHistory_'+index">
                    <v-list-tile
                            :key="obj.status"
                    >
                        <v-list-tile-content>
                            <v-list-tile-title v-html="timeFormat(obj.json)" class="cart_item"></v-list-tile-title>
                            <v-list-tile-sub-title>{{ obj.statusTransalated }}</v-list-tile-sub-title>
                        </v-list-tile-content>

                    </v-list-tile>
                    <v-divider></v-divider>
                </v-list>


                <p>ご注文いただきありがとうございました。</p>
                <p class="mt-4">ご注文の内容は次の通りです。</p>
                <h3 class="pa-1">ご注文内容</h3>
                <v-card class="text-xs-center" flat>
                    <table class="order-detail-table">
                        <tbody>
                        <tr>
                            <td>お届け予定時刻</td>
                            <td>{{userSelect.day.dayTextLang}} {{userSelect.deliveryTime.eta}}</td>
                        </tr>
                        <tr>
                            <td>お受取方法</td>
                            <td>お届け</td>
                        </tr>
                        <tr>
                            <td>店舗名</td>
                            <td>{{cart.premiseName}}</td>
                        </tr>
                        <tr>
                            <td>お届け業者名</td>
                            <td>{{dp.companyName}}</td>
                        </tr>
                        <tr>
                            <td>お届け先</td>
                            <td>
                                {{userSelect.name}} さま<br/>
                                {{userSelect.address}}<br/>
                                {{userSelect.tel}}<br/>
                                {{userSelect.email}}<br/>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                </v-card>

            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import  { Logger } from 'aws-amplify';
const logger = new Logger('OrderDetailDp','INFO');
import { AmplifyEventBus } from 'aws-amplify-vue'
import moment from 'moment-timezone'
//import HomeMessage from '../components/HomeMessage'
import {PriceMixIns} from '../mixins/price'

export default {
    //components: {'HomeMessage': HomeMessage,},
    mixins: [PriceMixIns],
    data() {
        return {
            orderId: undefined,
            receivedIoTMessage: [],
            orderDetail: {},
            cognitoId: "",
            lang: undefined,
            currency: undefined,
            dp:{},
            cart: {items: []},
            userSelect: {
                service: {
                    name: undefined,
                    langName: ""
                },
                day: {
                    dayText: "",
                    dayTextLang: "",
                    selectedNum: undefined
                },
                time: "",
                name: "",
                email: "",
                carType: "",
                carPlate: "",
                carColor: "",
                numOfGuest: "",
                deliveryTime:{
                    eta:""
                }
            },
            totalPrice: 0,
            totalPriceCurrency: "",
            statusHistory: [],
            buttonPressed: false,
            showCancelCustomerArrived: false,
            showArrivalButton: false,
            replyFromShop: false,
            isCaptured: false,
            refundedShown: false,
        }
    },
    created() {
        AmplifyEventBus.$on("mqttMessage", this.mqttMessageReceived)
    },
    beforeDestroy() {
        AmplifyEventBus.$off("mqttMessage", this.mqttMessageReceived)
    },
    async mounted() {
        AmplifyEventBus.$emit('setBackTo', "/history")
        AmplifyEventBus.$emit('setBottomBar', "history")
        this.orderId = this.$route.query.orderId
        const currentOrder = this.$store.state.currentOrder
        logger.info("currentOrder",currentOrder)
        if(currentOrder == {}){
            this.$router.push("/orderDetail?orderId="+this.orderId)
        }
        this.lang = currentOrder.dataToSend.lang
        this.currency = currentOrder.dataToSend.currency
        this.cart = currentOrder.dataToSend.cart
        this.dp = currentOrder.dataToSend.dp
        this.totalPrice = this.cart.total
        this.totalPriceCurrency = this.getCurrencyFormatted(this.totalPrice);
        this.userSelect = currentOrder.dataToSend.userSelect

        this.trackPage('/orderDetail/')
        // get dp status
        const apiUrl = "https://24d3ujue09.execute-api.ap-northeast-1.amazonaws.com/default/adt-consumers/orderDetail"
        const dataToSend = {}
        dataToSend.request = "orderDetail"
        dataToSend.orderId = this.orderId+"_dp"
        dataToSend.hostname = location.hostname
        dataToSend.cognitoIdentity = this.cognitoId
        logger.info("dp detail to send",dataToSend)
        const res = await this.axios.post(apiUrl,dataToSend)
        logger.info("dp detail received",res.data)
        this.statusHistory = this.sortStatusHistory(currentOrder.statusHistory,res.data.statusHistory)
    },
    methods:{
        mqttMessageReceived:function(data){
            if(data.orderId == this.orderId){
                logger.info("message for this oderId",data)
                const message = {}
                message.timestamp = Date.now()
                message.timeStr = moment(message.timestamp).tz("Asia/Tokyo").format('llll:s')

                if(data.type == "arrivalReplyFromShop"){
                    message.text = data.actionText
                    message.type = "success"
                }else if(data.type == "answerOrder"){
                    if(data.result == "captured"){
                        message.text = "おめでとうございます。お店が注文を承諾しました。"
                        message.type = "success"
                        this.showArrivalButton = true
                        this.isCaptured = true
                    }else if(data.result == "refunded" && !this.refundedShown){
                        this.refundedShown = true
                        message.text = "すみません。お店が注文をお受けできないそうです。"
                        message.type = "error"
                        message.veryVerySorry = true
                    }else if(data.result == "refunded_dp" && !this.refundedShown){
                        this.refundedShown = true
                        message.text = "すみません。配送会社が注文をお受けできないそうです。"
                        message.type = "error"
                        message.veryVerySorry = true
                    }
                }
                this.receivedIoTMessage.unshift(message)
            }
        },
        timeFormat(json){

            moment.locale(this.lang)
            return moment(json.timestamp).tz("Asia/Tokyo").format('llll:s')
        },
        sortStatusHistory(historyObj1,historyObj2){
            const statusHistoryArray = []
            for(let i in historyObj1){
                const obj = {}
                obj.status = i
                obj.json = JSON.parse(historyObj1[i])
                obj.isDp = false
                obj.statusTransalated = this.translateStatusHistory(i)
                statusHistoryArray.push(obj)
            }
            for(let i in historyObj2){
                const obj = {}
                obj.status = i
                obj.json = JSON.parse(historyObj2[i])
                obj.isDp = true
                obj.statusTransalated = this.translateStatusHistory(i)
                statusHistoryArray.push(obj)
            }
            statusHistoryArray.sort(compareStatusHistoryArray)
            logger.info("statusHistoryArray",statusHistoryArray)
            return statusHistoryArray

        },
        translateStatusHistory:function(key){
            const charToSubstr = "arrivalReplyFromShop_"
            if(key.substring(0,charToSubstr.length) == charToSubstr) {
                const replyMsgArray = key.split("_")
                return replyMsgArray[1]
            }else{
                switch(key) {
                    case "cancelCustomerArrived":
                        return "到着通知キャンセル"
                    case "customerArrived":
                        return "到着通知"
                    case "placed":
                        return "注文受信/カード与信確保"
                    case "refunding":
                        return "返金開始"
                    case "refunded":
                        return "返金完了"
                    case "accepted":
                        return "注文承諾"
                    case "denied":
                        return "注文拒否"
                    case "capturing":
                        return "カード決済開始"
                    case "captured":
                        return "カード決済完了"
                    default:
                        return key
                }
            }
        },
    }
}


const compareStatusHistoryArray = (a,b) => {
    const dateA = a.json.timestamp
    const dateB = b.json.timestamp
    let comparison = 0
    if(dateA < dateB){
        comparison = 1
    }else if(dateA > dateB){
        comparison = -1
    }
    return comparison
}
</script>

<style>
    .order-detail-table td{
        text-align: left;
        padding:5px;
        vertical-align: top;
    }

</style>